/**
 *  @class
 *  @function RecentlyViewedProducts
 */
/**
 *  @class
 *  @function RecentlyViewedProducts
 */
if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();

      this.url = `${theme.routes.search_url}?view=recently-viewed&type=product&q=`;
      this.container = this.querySelector('.products');
      this.currentId = this.dataset.productHandle;
      this.max = Number(this.dataset.max);
      this.requireFullSet = this.dataset.requireFullSet === 'true';
      this.products = '';
      this.section = this.closest('.shopify-section');
      const recentIds = window.localStorage.getItem('recently-viewed');
      try {
        const parsedIds = recentIds ? JSON.parse(recentIds) : [];
        window.recentlyViewedIds = Array.isArray(parsedIds) ? parsedIds : [];
      } catch (error) {
        window.recentlyViewedIds = [];
      }
      if (this.requireFullSet) this.hideSection();
    }

    connectedCallback() {
      this.buildUrl();
    }

    buildUrl() {
      const productHandles = [...new Set(window.recentlyViewedIds.filter(handle => handle && handle !== this.currentId))]
        .slice(0, this.max);
      if (!productHandles.length || (this.requireFullSet && productHandles.length < this.max)) return;
      this.products = productHandles.map(handle => `handle:${handle}`).join(' OR ');
      this.url += encodeURIComponent(this.products);

      this.fetchProducts(productHandles);
    }

    fetchProducts(productHandles) {
      fetch(this.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.products');

          if (recommendations && recommendations.innerHTML.trim().length) {
            const slidesByHandle = new Map(
              [...recommendations.querySelectorAll('.carousel__slide')]
                .map(slide => {
                  const href = slide.querySelector('a[href*="/products/"]')?.getAttribute('href') || '';
                  const handle = href.match(/\/products\/([^/?#]+)/)?.[1];
                  return [handle, slide.outerHTML];
                })
                .filter(([handle]) => Boolean(handle))
            );
            const renderedSlides = productHandles
              .map(handle => slidesByHandle.get(handle))
              .filter(Boolean);
            if (!renderedSlides.length || (this.requireFullSet && renderedSlides.length !== this.max)) return;
            this.container.innerHTML = renderedSlides.join('');
            this.classList.add('recently-viewed-products--loaded');
            if (this.requireFullSet) this.showSection();
            this.container.querySelectorAll('.lazyload').forEach((image) => {
              lazySizes.loader.unveil(image);
            });
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    hideSection() {
      this.section?.setAttribute('hidden', '');
    }

    showSection() {
      this.section?.removeAttribute('hidden');
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
